(function () {
	'use strict';
	angular.module('app.core')
		.config(function($translateProvider) {
			$translateProvider.translations('en_us',{
				'SUPPLY_ORDER_NUMBER': 'Order Number'
			});
		})
		.service('supplyOrderColumns', supplyOrderColumns);

	supplyOrderColumns.$inject = ['tableRenderService', '$experiments', 'siteService'];
	function supplyOrderColumns(tableRenderService, $experiments, siteService) {
		return [{
			id: 'purchaseDocumentType',
			display: 'Purchase Document Type',
			width: 60,
			sort: true
		}, {
			id: 'documentType',
			display: 'Document Type',
			width: 60,
			sort: true
		}, {
			id: 'erpDocumentType',
			display: 'ERP Document Type',
			width: 60,
			sort: true
		}, {
			id: 'orderCreationDate',
			display: 'Creation Date',
			width: 100,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			headerTitle: 'The date the order was created.',
			convertTimeZone: true,
			aliases: ['orderDate']
		}, {
			id: 'originalRequestedDate',
			display: 'Requested Date',
			width: 100,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			headerTitle: 'The original Requested Date for the Order.',
			convertTimeZone: true
		}, {
			id: 'prCreationDate',
			display: 'PR Creation Date',
			class: 'alignRight',
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true,
			width: 140,
			sort: true
		}, {
			id: 'requestedDate',
			display: 'Expected Delivery Date',
			width: 100,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			headerTitle: 'The current expected delivery date for the Order.',
			convertTimeZone: true,
			sortDefaultReverse: true
		}, {
			id: 'goldenSupplyDate',
			display: 'Expected Delivery Date',
			width: 100,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			headerTitle: 'The current expected delivery date for the Order.',
			convertTimeZone: true,
			sortDefaultReverse: true
		}, {
			id: 'confirmationStatusUsed',
			display: 'Expected Delivery Date Status',
			width: 200,
			sort: true,
			headerTitle: 'The committment level of the supply order requested date',
			renderer: tableRenderService.confirmationStatusUsed
		}, {
			id: 'analysisRequirementDate',
			display: 'Earliest Demand Date',
			width: 100,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			headerTitle: 'The date of the earliest demand that needs this PO.',
			convertTimeZone: true
		}, {
			id: 'analysisRescheduleDate',
			display: 'Recommended Reschedule Date',
			width: 110,
			sort: true,
			renderer: tableRenderService.poRecommendationRenderer,
			headerTitle: 'The recommended date to reschedule this PO to maintain safety stock and account for receiving time.',
			convertTimeZone: true
		}, {
			id: 'supplyOrderImpactingShortage',
			display: 'Supply Order Impacting Shortage',
			width: 110,
			sort: true,
			renderer: tableRenderService.supplyOrderImpactingShortageRenderer,
			headerTitle: 'Determines if this Supply Order is impacting the item to be short.'
		}, {
			id: 'clearToBuildPriority',
			display: 'Clear to Build Priority',
			width: 110,
			sort: true,
			renderer: tableRenderService.clearToBuildPriorityRenderer,
			headerTitle: 'Determines if this Supply Order is impacting a priority production order.'
		}, {
			id: 'depthOfDelay',
			display: 'Depth of Delay (days)',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.integer,
			headerTitle: 'Days between requirement date and Requested Date.'
		}, {
			id: 'poAction',
			display: 'PO Action',
			width: 100,
			sort: true,
			renderer: tableRenderService.poRecommendationRenderer,
			headerTitle: 'Recommended action to take on this PO.'
		}, {
			id: 'ageOfPoAction',
			display: 'Age of PO Action (days)',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.poRecommendationRenderer,
			headerTitle: 'Days since the current action was recommended.'
		}, {
			id: 'rescheduleDate',
			display: 'Reschedule Date',
			width: 120,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true,
			aliases: ['reScheduleDate']
		}, {
			id: 'promiseDate',
			display: 'Current Supplier Commit Date',
			width: 120,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			sortDefaultReverse: true,
			convertTimeZone: true
		}, {
			id: 'scorecardDate',
			display: 'Scorecard Accountability Date',
			width: 120,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			sortDefaultReverse: true,
			convertTimeZone: true,
			uibTooltip: "The date used for Delivery Score based on the site\\'s setting"
		}, {
			id: 'deliveryScoreGroupingDate',
			display: 'Delivery Score Grouping Date',
			width: 120,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			sortDefaultReverse: true,
			convertTimeZone: true,
			uibTooltip: "The date used for Delivery Score Grouping based on the site\\'s setting"
		}, {
			id: 'actualReceiptDate',
			display: 'Actual Receipt Date',
			width: 120,
			sort: true,
			renderer: tableRenderService.receivedDate,
			headerTitle: 'The date that the item was actually received',
			convertTimeZone: true,
			aliases: ['receiptDate']
		}, {
			id: 'deliveryStatus',
			display: 'Delivery Status',
			width: 120,
			sort: true,
			renderer: tableRenderService.purchaseOrderDeliveryStatus
		}, {
			id: 'purchaseOrderNumber',
			display: 'PO Number',
			width: 100,
			sort: true
		}, {
			id: 'supplyOrderNumber',
			display: 'SUPPLY_ORDER_NUMBER',
			width: 100,
			sort: true
		}, {
			id: 'purchaseOrderLine',
			display: 'PO Line',
			width: 60,
			sort: true
		}, {
			id: 'orderLine',
			display: 'Order Line',
			width: 60,
			sort: true
		}, {
			id: 'scheduleLine',
			display: 'Schedule Line',
			width: 60,
			sort: true
		}, {
			id: 'remainingQuantityFloat',
			display: 'Remaining Qty',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.integer,
			headerTitle: 'The open quantity that is currently awaiting delivery',
			aliases: ['remainingQuantity']
		}, {
			id: 'totalOrderedQuantity',
			display: 'Total Ordered Quantity',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.integer,
			headerTitle: 'The original quantity that was ordered.'
		}, {
			id: 'deliveredQuantity',
			display: 'Delivered Quantity',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.integer,
			headerTitle: 'The quantity that has been received'
		}, {
			id: 'unitPrice',
			display: 'Unit Price',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.currency,
			keepAllDecimals: true
		}, {
			id: 'poValue',
			display: 'Order Value',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.currency,
			headerTitle: 'The total value of the PO that has yet to be received.',
			aliases: 'POValue'
		}, {
			id: 'totalPoValue',
			display: 'Total Order Value',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.currency,
			headerTitle: 'The total value of the PO.'
		}, {
			id: 'poValueStandard',
			display: 'Open PO Value (Standard Price)',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.currency,
			headerTitle: 'The total value of the PO that has yet to be received.'
		}, {
			id: 'totalPoValueStandard',
			display: 'Total PO Value (Standard Price)',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.currency,
			headerTitle: 'The total value of the PO.'
		}, {
			id: 'poValuePPV',
			display: 'Future PPV',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.futurePPVRenderer,
			headerTitle: 'The difference between the order value and the value at standard price.'
		}, {
			id: 'poLeadTime',
			display: 'Order Lead Time',
			class: 'alignRight',
			renderer: tableRenderService.leadTime,
			width: 150,
			sort: true,
			headerTitle: 'The amount of time (in days) between the Order Date and the Requested Date.'
		}, {
			id: 'actualLeadTime',
			display: 'Actual Lead Time',
			class: 'alignRight',
			renderer: tableRenderService.leadTime,
			width: 150,
			sort: true,
			headerTitle: 'The amount of time (in days) between the Order Date and the Actual Receipt Date.'
		}, {
			id: 'validityStartDate',
			display: 'Validity Start Date',
			width: 100,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		}, {
			id: 'validityEndDate',
			display: 'Validity End Date',
			width: 100,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		}, {
			id: 'fixedPOFlag',
			display: 'Fixed Flag',
			width: 100,
			sort: true
		}, {
			id: 'notes',
			display: 'Notes',
			width: 100,
			sort: false,
			aliases: ['poNotes']
		}, {
			id: 'exceptionMessage',
			display: 'ERP exception message',
			width: 100,
			sort: false,
			headerTitle: 'The ERP exception message taken from the system (move in, move out, cancel, etc).',
			aliases: ['poExceptionMsg']
		}, {
			id: 'businessUnit',
			display: 'Business Unit',
			width: 100,
			sort: true
		}, {
			id: 'division',
			display: 'Division',
			width: 100,
			sort: true
		}, {
			id: 'entity',
			display: 'Entity',
			width: 100,
			sort: true
		}, {
			id: 'prNumber',
			display: 'PR Number',
			width: 80,
			sort: true
		},{
			id: 'externalMaterialGroup',
			display: 'External Material Group',
			width: 140,
			sort: true
		}, {
			id: 'prOnTimeDate',
			display: 'On Time Date',
			class: 'alignRight',
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true,
			width: 140,
			sort: true
		}, {
			id: 'poOnTimeFirmDate',
			display: 'On Time Firm Date',
			class: 'alignRight',
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true,
			width: 140,
			sort: true
		}, {
			id: 'deliveryDate',
			display: 'Delivery Date',
			class: 'alignRight',
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true,
			width: 140,
			sort: true
		}, {
			id: 'notificationLeadTimeDays',
			display: 'Notification Lead Time (Days)',
			class: 'alignRight',
			width: 140,
			sort: true
		}, {
			id: 'notificationLeadTimeWeeks',
			display: 'Notification Lead Time (Weeks)',
			class: 'alignRight',
			width: 140,
			sort: true
		}, {
			id: 'daysInsideSupplierLeadTimeAtCreation',
			display: 'Days Inside Lead Time at Creation',
			class: 'alignRight',
			width: 140,
			sort: true
		}, {
			id: 'daysInsideProcurementLeadTimeAtCreation',
			display: 'Days Inside Procurement Lead Time at Creation',
			class: 'alignRight',
			width: 140,
			sort: true
		}, {
			id: 'daysUntilPOFirm',
			display: 'Days Until Firm',
			class: 'alignRight',
			renderer: tableRenderService.daysUntilPOFirmRenderer,
			width: 140,
			sort: true
		}, {
			id: 'daysUntilProcurementLeadTime',
			display: 'Days Until Procurement Lead Time',
			class: 'alignRight',
			width: 140,
			sort: true
		}, {
			id: 'erpStatus',
			display: 'ERP Status',
			class: 'alignRight',
			width: 140,
			sort: false
		}, {
			id: 'poErpStatus',
			display: 'PO ERP Status',
			class: 'alignRight',
			width: 140,
			sort: false
		}, {
			id: 'excessAtOtherSites',
			display: 'Excess at Other Sites',
			width: 80,
			sort: true,
			renderer: tableRenderService.excessAtOtherSites,
			sortDefaultReverse: true
		}, {
			id: 'firstPoStatus',
			display: 'Supply Order Status',
			width: 190,
			sort: false,
			renderer: tableRenderService.inlineEdit,
			editType: 'poComment',
			maxInputLength: 2500,
			disabled: ($experiments.isEnabled('supply-order-forecast') && globalConfig.customer.id !== 90) || siteService.isSpiritSupplier(), // disable if forecast is enabled
			peggingTooltip: 'Supply pegged to this order'
		}, {
			id: 'firstPoTrackingNumber',
			display: 'Supply Order Tracking Number',
			width: 190,
			sort: false,
			renderer: tableRenderService.inlineEdit,
			editType: 'poComment',
			disabled: $experiments.isEnabled('supply-order-forecast'), // disable if forecast is enabled
			peggingTooltip: 'Supply pegged to this order'
		}, {
			id: 'firstPoEcdDate',
			display: 'Supply Order Commit Date',
			width: 100,
			sort: false,
			renderer: tableRenderService.inlineEditDate,
			disabled: $experiments.isEnabled('supply-order-forecast'), // disable if forecast is enabled
			removeTimezoneOffset: true,
			peggingTooltip: 'Supply pegged to this order',
			showApprovalModal: false
		}, {
			id: 'firstPoStatusLastModified',
			display: 'Last Supply Order Status Update',
			width: 100,
			sort: true,
			isReverseSort: true,
			renderer: tableRenderService.relativeDate,
			disabled: $experiments.isEnabled('supply-order-forecast') // disable if forecast is enabled
		}, {
			id: 'firstPoEcdLastModified',
			display: 'Last Supply Order Commit Date Update',
			width: 100,
			sort: true,
			isReverseSort: true,
			renderer: tableRenderService.relativeDate,
			disabled: $experiments.isEnabled('supply-order-forecast') // disable if forecast is enabled
		}, {
			id: 'lateDeliveryDescription',
			display: 'Late/Early Delivery Cause',
			width: 100,
			sort: false,
			renderer: tableRenderService.inlineEdit,
			editType: 'poComment'
		}, {
			id: 'poStatusCategoryDescription',
			display: 'Supply Order Status Category',
			width: 100,
			sort: false,
			renderer: tableRenderService.inlineEdit,
			editType: 'poComment',
			peggingTooltip: 'Supply pegged to this order',
			disabled: siteService.isSpiritSupplier() // disable if forecast is enabled
		}, {
			id: 'lateDeliveryLiability',
			display: 'Late/Early Delivery Liability',
			width: 80,
			sort: true,
			renderer: tableRenderService.lateDeliveryIssue
		}, {
			id: 'forecastDeliveryCount',
			display: 'Scheduled Deliveries',
			width: 80,
			sort: true,
			renderer: tableRenderService.forecastDelivery,
			disabled: !$experiments.isEnabled('supply-order-forecast'),
			editable: true
		}, {
			id: 'forecastTotalQuantity',
			display: 'Scheduled Quantity',
			width: 80,
			sort: true,
			renderer: tableRenderService.forecastDelivery,
			disabled: !$experiments.isEnabled('supply-order-forecast'),
			editable: true
		}, {
			id: 'forecastFirstDeliveryQuantity',
			display: 'First Delivery Quantity',
			width: 80,
			sort: true,
			renderer: tableRenderService.forecastDelivery,
			disabled: !$experiments.isEnabled('supply-order-forecast'),
			editable: true
		}, {
			id: 'forecastFirstDeliveryDate',
			display: 'First Delivery Date',
			width: 80,
			sort: true,
			renderer: tableRenderService.forecastDelivery,
			convertTimeZone: true,
			disabled: !$experiments.isEnabled('supply-order-forecast'),
			editable: true
		}, {
			id: 'forecastFirstTrackingNumber',
			display: 'First Delivery Tracking Number',
			width: 80,
			sort: true,
			renderer: tableRenderService.forecastDelivery,
			convertTimeZone: true,
			disabled: !$experiments.isEnabled('supply-order-forecast'),
			editable: true
		}, {
			id: 'forecastFirstComment',
			display: 'First Delivery Comment',
			width: 80,
			sort: true,
			renderer: tableRenderService.forecastDelivery,
			convertTimeZone: true,
			disabled: !$experiments.isEnabled('supply-order-forecast'),
			editable: true
		}, {
			id: 'placementDaysLate',
			display: 'PO Placement Time',
			width: 80,
			sort: true,
			renderer: tableRenderService.poPlacementTime
		}, {
			id: 'poStatus',
			display: 'Confirmation Status',
			width: 100,
			renderer: tableRenderService.poConfirmationStatus,
			sort: true || $experiments.isEnabled('supply-order-forecast')
		}, {
			id: 'confirmDate',
			display: 'Confirm Date',
			width: 80,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		}, {
			id: 'insideLeadTime',
			display: 'Created Inside Lead Time',
			width: 120,
			sort: true,
			renderer: tableRenderService.yesNo
		}, {
			id: 'prHistoryDate',
			display: 'PR Log Date',
			width: 120,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		}, {
			id: 'workbenchPriority',
			display: 'Priority',
			sort: false
		},
		{
			id: 'poIdentifier',
			display: 'PO Identifier',
			width: 300,
			sort: true,
			sortDefaultReverse: true,
			show: true,
			renderer: tableRenderService.poIdentifier,
			disabled: !$experiments.isEnabled('chat-enabled') // disable if chat is not enabled
		},
		{
			id: 'isBlanketOrder',
			display: 'Blanket Order',
			width: 300,
			sort: false,
			show: true,
			renderer: tableRenderService.isBlanketOrder,
			disabled: !$experiments.isEnabled('supply-and-demand-blanket-checkbox') // disable if blanket orders filter is not enabled
		},
		{
			id: 'orderStartDate',
			display: 'Order Start Date',
			width: 80,
			sort: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		},
		{
			id: 'isMoveInForRequirement',
			display: 'Move in for requirement',
			width: 300,
			sort: false,
			show: true,
			renderer: tableRenderService.isMoveInForRequirement
		},
		{
			id: 'incoterms',
			display: 'Incoterms',
			width: 150,
			sort: true,
			show: true
		},
		{
			id: 'requestedShippingDate',
			display: 'Requested shipping date',
			width: 300,
			sort: true,
			show: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		},
		{
			id: 'confirmedShippingDate',
			display: 'Confirmed shipping date',
			width: 300,
			sort: true,
			show: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		},
		{
			id: 'actualShippedDate',
			display: 'Actual shipped date',
			width: 300,
			sort: true,
			show: true,
			renderer: tableRenderService.dateRenderer,
			convertTimeZone: true
		},
		{
			id: 'peggingKey',
			display: 'Pegging key',
			width: 120,
			sort: false,
			show: false,
			conditional: hideFromExternal
		}, {
			id: 'confirmationDocumentId',
			display: 'Confirmation Tracking ID',
			width: 120,
			sort: false,
			show: false
		}, {
			id: 'confirmationLine',
			display: 'Confirmation Line',
			width: 60,
			sort: true,
			show: false
		}, {
			id: 'confirmationArrivalDate',
			display: 'Confirmation Promise Date',
			width: 100,
			sort: true,
			isReverseSort: true,
			renderer: tableRenderService.dateRenderer
		}, {
			id: 'confirmedQuantity',
			display: 'Confirmed Qty',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.integer,
			headerTitle: 'Quantity confirmed by supplier in ERP.'
		}, {
			id: 'shipmentDocumentId',
			display: 'Shipment Tracking ID',
			width: 120,
			sort: false,
			show: false
		}, {
			id: 'shipmentLine',
			display: 'Shipment Line',
			width: 60,
			sort: true,
			show: false
		}, {
			id: 'shipmentArrivalDate',
			display: 'Shipment Promise Date',
			width: 100,
			sort: true,
			isReverseSort: true,
			renderer: tableRenderService.dateRenderer
		}, {
			id: 'shippedQuantity',
			display: 'Shipped Qty',
			class: 'alignRight',
			width: 100,
			sort: true,
			renderer: tableRenderService.integer,
			headerTitle: 'Quantity shipped by supplier.'
		}, {
			id: 'location',
			display: 'Location',
			width: 100,
			sort: true
		}, {
			id: 'requirementStatus',
			display: 'Requirement Status',
			width: 120,
			sort: true
		}];
	};

	function hideFromSuppliers() {
		return globalConfig.user.role !== 'Supplier';
	}

	function hideFromSpiritSuppliers() {
		return globalConfig.user.role !== 'Supplier' || globalConfig.customer.id !== 90;
	}

	function hideFromExternal() {
		return globalConfig.user.userName.endsWith('@leandna.com');
	}
})();
